// utils/stagedLoad.ts — prioritas load bertahap (bukan serentak).
// Fase 1: mount (konten kritis). Fase 2: konten SIAP + idle (dropdown,
// ongkir, pixel fire). Fase 3: idle lanjutan (analitik, presence).
// Event-based (bukan timer buta): fase 2 menunggu `active` = konten tampil.
// Pola pakai di effect: `if (phase < 2) return;` + tambahkan phase ke deps.
import { useEffect, useState } from 'react';
import { onIdle } from './idleCallback';

export type LoadPhase = 1 | 2 | 3;

/** Naik fase saat konten siap; 2 = idle cepat, 3 = idle santai. */
export function useLoadPhase(active: boolean): LoadPhase {
    const [phase, setPhase] = useState<LoadPhase>(1);
    useEffect(() => {
        if (!active) return;
        const off2 = onIdle(() => setPhase(2), 800);
        const off3 = onIdle(() => setPhase(3), 2500);
        return () => { off2(); off3(); };
    }, [active]);
    return phase;
}
